import { useFormContext } from "react-hook-form";
import {
  Field,
  FieldDescription,
  FieldGroup,
  FieldLabel,
  FieldSet,
} from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export type NoticeOutputPopupFormPayload = {
  title: string;
  message: string;
  ctaLabel?: string; // optional
};

export function NoticeOutputPopupForm() {
  const {
    register,
    formState: { errors },
  } = useFormContext<NoticeOutputPopupFormPayload>();

  return (
    <FieldGroup>
      <FieldSet>
        <FieldGroup>
          <Field>
            <FieldLabel htmlFor="checkout-7j9-card-name-43j">Title</FieldLabel>
            <Input
              placeholder="Popup Title"
              {...register("title", { required: true })}
            />
          </Field>

          <Field>
            <FieldLabel htmlFor="checkout-7j9-optional-comments">
              Message
            </FieldLabel>
            <Textarea
              placeholder="This is a popup notification"
              className="resize-none min-h-[160px]"
              {...register("message", { required: true })}
            />
          </Field>

          <Field>
            <FieldLabel htmlFor="checkout-7j9-card-number-uw1">
              CTA Label
            </FieldLabel>
            <Input placeholder="I understand" {...register("ctaLabel")} />
          </Field>
        </FieldGroup>
      </FieldSet>
    </FieldGroup>
  );
}
